/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvperfmonTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface NvPerfMonPlugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GpuFanPerfMetrics".
 */
export interface GpuFanPerfMetrics {
    /**
     * gpu fan speed in RPM
     */
    fanSpeed?: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GpusPerfStats".
 */
export interface GpusPerfStats {
    /**
     * indicate gpu index
     */
    gpuIndex?: number;
    /**
     * gpu utilization in percentage
     */
    gpuUtil?: number;
    /**
     * GPU memory clock
     */
    vramClock?: number;
    /**
     * GPU voltage in percentage
     */
    gpuVoltage?: number;
    /**
     * gpu temperature
     */
    gpuTemp?: number;
    /**
     * gpu frequency
     */
    gpuClock?: number;
    gpuFanSpeed?: GpuFanPerfMetrics[];
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "FilePath".
 */
export interface FilePath {
    /**
     * Default value of logging file path
     */
    logpath?: string;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GpuInfo".
 */
export interface GpuInfo {
    /**
     * Index of GPU
     */
    index?: number;
    /**
     * Name of the GPU
     */
    Name?: string;
}
/**
 * error feedback bits for override features
 *
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "NGXOverrideErrFeedback".
 */
export interface NGXOverrideErrFeedback {
    [k: string]: any;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "EnablePerfStatsNotificationParameters".
 */
export interface EnablePerfStatsNotificationParameters {
    /**
     * whether to enable perf stats notification
     */
    isEnable: boolean;
    /**
     * polling interval in milisec
     */
    intervalMS: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "EnablePerfStatsNotificationReturn".
 */
export interface EnablePerfStatsNotificationReturn {
    /**
     * true if successfully stated otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "RegisterPerfStatsNotificationsReturn".
 */
export interface RegisterPerfStatsNotificationsReturn {
    gpusPerfStats?: GpusPerfStats[];
    /**
     * average FPS for current app
     */
    fps?: number;
    /**
     * FPS 1% Low for current app
     */
    fps1pc?: number;
    /**
     * Disp Avg FPS for current app
     */
    fpsdispavg?: number;
    /**
     * Disp FPS 1% Low for current app
     */
    fpsdisp1pc?: number;
    /**
     * Render Latency
     */
    renderLatency?: number;
    /**
     * Render Present Latency
     */
    renderingPresentLatency?: number;
    /**
     * tgpWatts
     */
    gpuPower?: number;
    /**
     * cpu Utilization
     */
    cpuUtil?: number;
    /**
     * CPU Power in Watts
     */
    cpuPower?: number;
    /**
     * CPU Frequency in MHz
     */
    cpuFreq?: number;
    /**
     * CPU Package Temperature in Celsius
     */
    cpuPkgTemp?: number;
    gSyncLamp?: {
        /**
         * true if LAM is enabled otherwise false
         */
        lamEnabled?: boolean;
        /**
         * PC Display latency
         */
        pcDisplayLatency?: number;
        /**
         * Avarage PC Display latency
         */
        avgPcDisplayLatency?: number;
        /**
         * Average PC Latency
         */
        avgPCLatency?: number;
        mouseLatency?: {
            latency?: number;
            /**
             * 1 indicate latency is coming from mouse lookup table, 0 indicate LAM module latency value
             */
            latencySource?: number;
            /**
             * 1 indicate unverified FW, 0 indicate verified FW
             */
            unverifiedFW?: number;
        };
        avgMouseLatency?: {
            latency?: number;
            /**
             *  1 indicate if avg mouse latency adjustment is being applied or not
             */
            polledActuation?: number;
        };
        monitorLatency?: number;
        /**
         *  E2E system latency
         */
        systemLatency?: number;
        /**
         *  avarage E2E system latency
         */
        avgSystemLatency?: number;
        reflexMonitorPosition?: {
            width?: number;
            height?: number;
            topleftx?: number;
            toplefty?: number;
        };
    };
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "SetProcessIdParameters".
 */
export interface SetProcessIdParameters {
    /**
     * process id of application
     */
    processId: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "SetMetricSampleSizeParameters".
 */
export interface SetMetricSampleSizeParameters {
    /**
     * sample size of metrics
     */
    sampleSize: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GetDefaultLoggingPathReturn".
 */
export interface GetDefaultLoggingPathReturn {
    path: FilePath;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "LoggingToggleParameters".
 */
export interface LoggingToggleParameters {
    /**
     * status of perfmetrics logging
     */
    enable: boolean;
    /**
     * path of the log file
     */
    path?: string;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GetRLAMonitorSupportReturn".
 */
export interface GetRLAMonitorSupportReturn {
    /**
     * Defines if RLA Monitor is supported
     */
    supported: boolean;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "ShowFlashIndicatorParameters".
 */
export interface ShowFlashIndicatorParameters {
    /**
     * visibility of Reflex Flash Indicator
     */
    isVisible: boolean;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "SetFlashIndicatorSizeParameters".
 */
export interface SetFlashIndicatorSizeParameters {
    /**
     * Small size if false else large
     */
    size: boolean;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GetGpuInfoReturn".
 */
export interface GetGpuInfoReturn {
    /**
     * true if success otherwise false
     */
    result: boolean;
    gpus: GpuInfo[];
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "powerStatusNotificationReturn".
 */
export interface powerStatusNotificationReturn {
    powerStatus?: PowerStatus;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "CheckRLASupportedDriverReturn".
 */
export interface CheckRLASupportedDriverReturn {
    /**
     * Defines if Driver supports RLA feature
     */
    supported: boolean;
    /**
     * Driver version
     */
    driverVersion: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideStateParameters".
 */
export interface GetNGXOverrideStateParameters {
    /**
     * processId of the application.
     */
    processId: number;
    /**
     * cmsId of the application.
     */
    cmsId: number;
}
/**
 * This interface was referenced by `NvPerfMonPlugin`'s JSON-Schema
 * via the `definition` "GetNGXOverrideStateReturn".
 */
export interface GetNGXOverrideStateReturn {
    /**
     * override engaged SR
     */
    dlssOverrideFlagEvaluateSR?: boolean;
    /**
     * override engaged RR
     */
    dlssOverrideFlagEvaluateRR?: boolean;
    /**
     * override engaged FG
     */
    dlssOverrideFlagEvaluateFG?: boolean;
    /**
     * Array of SR error feedback
     */
    errFeedbackSR?: NGXOverrideErrFeedback[];
    /**
     * Array of RR error feedback
     */
    errFeedbackRR?: NGXOverrideErrFeedback[];
    /**
     * Array of FG error feedback
     */
    errFeedbackFG?: NGXOverrideErrFeedback[];
    /**
     * Applied Performance Mode Override setting value
     */
    performanceMode?: number;
    /**
     * Applied Override Feature Preset value
     */
    renderPreset?: number;
    /**
     * Applied FG Frame Count value
     */
    frameGenerationCount?: number;
    /**
     * Applied Perf Scaling Factor value
     */
    scalingRatio?: number;
    /**
     * Applied FG Preset value
     */
    frameGenerationPreset?: number;
    /**
     * Applied FG Mode value
     */
    frameGenerationMode?: number;
}

/**
 * power status. 0-AC, 1-DC
 */
export enum PowerStatus {
    AC = 0,
    DC = 1,
    UPS_LIKE = 2,
    Unknown = 3
}


}
